export default __webpack_public_path__ + "static/media/gardenRain.11d00a2e.mp4";